import { Injectable } from '@angular/core';
import {
  HttpErrorResponse, HttpEvent, HttpHandler,
  HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Observable, throwError} from 'rxjs';
import { catchError, first, map, switchMap } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import * as fromRoot from '../../../store/reducers';
import { getSelected } from '../../../store/reducers/vpo';
import { Router } from '@angular/router';


@Injectable()
export class ExtraDataInterceptor implements HttpInterceptor {

  constructor(private store: Store<fromRoot.AppState>,
              private route: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if ( this.route.url.startsWith('/manage') || this.route.url.startsWith('/test7799/manage') ) {
      //
      return next.handle(request)
        .pipe(
          catchError((error: HttpErrorResponse) => throwError(error))
        );
    }

    const vpo$ = this.store
      .pipe(
        select(fromRoot.selectVpoState()),
        map((state: any) => getSelected(state))
      );

    return vpo$
      .pipe(
        map( vpo => (vpo ? vpo.id : null)),
        first( id => id !== null || request.url.indexOf('vpo_active') !== -1),
        map( id => ( id ? request.clone({setHeaders: {'id-vpo': `${id}`}}) :  request)),
        switchMap( cloneRequest => next.handle(cloneRequest)),
        catchError((error: HttpErrorResponse) => throwError(error))
      );
  }
}
